import { Shinsei, Kiken } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit(form: Shinsei) {

  let kiken: Kiken[] = reactive([{
    shinsei_date: null,
  }]);

  if(form.kiken){
    kiken = form.kiken;
  }else{
    form.kiken = kiken;
  }


  return {
    kiken
  }
}
